import { Leaf } from 'lucide-react';

import { Co2Emission } from '@/lib/models/emissions/types';
import { EmissionStats } from '@/types';
import { formatEmissionsRangeString, formatEmissionsString } from '@/utils/format/emissions';
import { tv } from '@/utils/styles';

interface EmissionsBadgeProps {
  emissions?: Co2Emission;
  emissionStats?: EmissionStats;
  includeSuffix?: boolean;
}

const EmissionsBadge = ({ emissions, emissionStats, includeSuffix }: EmissionsBadgeProps) => {
  const { base } = styles();

  return (
    <div className={base()}>
      <Leaf />
      {emissions ? formatEmissionsString(emissions.wtw, emissions.unit) : ''}
      {emissionStats ? formatEmissionsRangeString(emissionStats, includeSuffix) : ''}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'inline-flex items-center gap-1 rounded-full bg-grey-50 px-1.5 py-0.5 text-sm text-grey-700 [&_svg]:size-3 [&_svg]:fill-green-500',
  },
});

export { EmissionsBadge };
